type Tone = "accent" | "safe" | "warn" | "danger";

export function StatusPill({
  label,
  value,
  unit,
  tone,
}: {
  label: string;
  value: string | number;
  unit?: string;
  tone?: Tone;
}) {
  return (
    <div className="status-pill">
      <div className="label">{label}</div>
      <div className={`value${tone ? ` ${tone}` : ""}`}>
        {value}
        {unit && <span className="unit">{unit}</span>}
      </div>
    </div>
  );
}
